module.exports = __webpack_public_path__ + "static/media/041.1dbf7a8b.jpg";